// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-toggle[data-v-292bd774],\n.icon-delete[data-v-292bd774] {\n\tdisplay: inline-block;\n\twidth: 16px;\n\theight: 16px;\n\tpadding: 10px;\n\tvertical-align: middle;\n}\ntd code[data-v-292bd774] {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tpadding: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
